import styled from "styled-components";
import { Form } from "antd";

export const StyledLoginForm = styled(Form)`
    .ant-form-item-explain{
        color:red
    }
`